import { GLOBAL_HEADER_HEIGHT } from "@/constants/styles/header";
import {
	Badge,
	Button,
	Container,
	Flex,
	Text,
	useMantineTheme,
} from "@mantine/core";
import { IconChevronLeft } from "@tabler/icons-react";
import { useNavigate } from "@tanstack/react-router";

type Props = {
	initialTitle: string;
	onSubmit: () => void;
	isSubmitDisabled?: boolean;
	isSample?: boolean;
};

export const RecruitPositionDetailHeader = ({
	initialTitle,
	onSubmit,
	isSubmitDisabled = false,
	isSample = false,
}: Props) => {
	const navigate = useNavigate();
	const theme = useMantineTheme();

	return (
		<header
			style={{
				height: GLOBAL_HEADER_HEIGHT,
				backgroundColor: "white",
				borderBottom: `1px solid ${theme.colors.gray[3]}`,
			}}
		>
			<Container
				size="xl"
				style={{
					height: GLOBAL_HEADER_HEIGHT,
					display: "flex",
					alignItems: "center",
					justifyContent: "space-between",
				}}
			>
				<Flex align="center" gap={12}>
					<IconChevronLeft
						size={24}
						style={{ cursor: "pointer" }}
						onClick={() => navigate({ to: "/recruit-positions" })}
					/>
					<Flex align="center" gap={8}>
						<Text fz="lg" mb={2}>
							{initialTitle}
						</Text>
						{isSample === true && (
							<Badge variant="light" color="indigo" radius="xl" size="md">
								サンプル
							</Badge>
						)}
					</Flex>
				</Flex>
				<Button onClick={onSubmit} disabled={isSubmitDisabled}>
					<Text>保存</Text>
				</Button>
			</Container>
		</header>
	);
};
